'use strict';

var map = {
  '@ctitle': "{{$lorem.sentence(locale='zh_CN')}}",
  '@cword': "{{$lorem.word(locale='zh_CN')}}",
  '@cparagraph': "{{$lorem.paragraph(locale='zh_CN')}}",
  '@csentence': "{{$lorem.sentence(locale='zh_CN')}}",
  '@cname': "{{$person.fullName(locale='zh_CN')}}",
  '@cfirst': "{{$person.lastName(locale='zh_CN')}}",
  '@clast': "{{$person.firstName(locale='zh_CN')}}",
  '@image': '{{$image.urlPlaceholder}}',
  '@phone': '{{$phone.mobile}}',
  '@ip': '{{$internet.ipv4}}',
  '@now': '{{$date.now}}',
  '@datetime': '{{$date.anytime}}',
  '@timestamp': '{{$date.timestamp}}',
  '@date': "{{$date.anytime|format('yyyy-MM-dd')}}",
  '@time': "{{$date.anytime|format('HH:mm:ss')}}",
  '@email': '{{$internet.email}}',
  '@string': '{{$string.sample}}',
  '@natural': '{{$number.int}}',
  '@float': '{{$number.float}}',
  '@character': '{{$string.alphanumeric}}',
  '@boolean': '{{$datatype.boolean}}',
  '@domain': '{{$internet.domainName}}',
  '@id': '{{$person.idCard}}',
  '@increment': '{{$helper.autoIncrementEnvVar}}',
  '@guid': '{{$string.uuid}}',
  '@dataImage': '{{$image.dataUri}}',
  '@color': '{{$color.rgb}}',
  '@hex': '{{$color.rgb}}',
  '@rgba': "{{$color.rgb(format='css',includeAlpha=true)}}",
  '@rgb': "{{$color.rgb(format='css')}}",
  '@hsl': "{{$color.hsl(format='css')}}",
  '@integer': '{{$number.int(min=-9007199254740992,max=9007199254740992)}}',
  '@paragraph': "{{$lorem.paragraph(locale='en')}}",
  '@sentence': "{{$lorem.sentence(locale='en')}}",
  '@word': "{{$lorem.word(locale='en')}}",
  '@title': "{{$lorem.sentence(locale='en')}}",
  '@name': "{{$person.fullName(locale='en')}}",
  '@first': "{{$person.firstName(locale='en')}}",
  '@last': "{{$person.lastName(locale='en')}}",
  '@region': '{{$location.region}}',
  '@province': '{{$location.state}}',
  '@city': '{{$location.city}}',
  '@county': '{{$location.county}}',
  '@zip': '{{$location.zipCode}}',
  '@protocol': '{{$internet.protocol}}',
  // 带参数
  '@regexp(/(0\\d{2}-\\d{8}(-\\d{1,4})?)|(0\\d{3}-\\d{7,8}(-\\d{1,4})?)/)': "{{$phone.landline}}",
  '@regexp(/[1-9]\\d{5}(18|19|20)\\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]/)': "{{$person.idCard}}",
  '@regexp(/[1-9][0-9]{4,}/)': '{{$internet.qq}}',
  '@url("http")': "{{$internet.url(protocol='http')}}",
  '@regexp(/\\d+/)': "{{$helpers.fromRegExp('/\\\\d+/')}}",
  '@domain("com")': "{{$internet.domainWord|concat('.com')}}",
  // '@increment(100)': '',
  '@city(true)': "{{$location.state}} {{$location.city}}",
  '@county(true)': '{{$location.state}} {{$location.city}} {{$location.county}}',
  '@upper("hello")': "{{$helpers.arrayElement(['hello'])|upper}}",
  '@lower("HELLO")': "{{$helpers.arrayElement(['HELLO'])|lower}}",
  "@pick(['a','b','c','d'])": "{{$helpers.arrayElement(['a','b','c','d'])}}",
  // "@shuffle(['a','b','c','d'])": '',
  '@date("yyyy-MM-dd")': "{{$date.anytime|format('yyyy-MM-dd')}}",
  '@date("yy-MM-dd")': "{{$date.anytime|format('yy-MM-dd')}}",
  '@date("y-MM-dd")': "{{$date.anytime|format('yy-MM-dd')}}",
  '@date("y-M-d")': "{{$date.anytime|format('yy-M-d')}}",
  '@datetime("yyyy-MM-dd A HH:mm:ss")': "{{$date.anytime|format('yyyy-MM-dd a HH:mm:ss',locale='en')}}",
  '@datetime("yy-MM-dd a HH:mm:ss")': "{{$date.anytime|format('yy-MM-dd aaa HH:mm:ss',locale='en')}}",
  '@datetime("y-MM-dd HH:mm:ss")': "{{$date.anytime|format('yy-MM-dd HH:mm:ss')}}",
  '@now("year")': "{{$date.now|startOfYear|format('yyyy-MM-dd HH:mm:ss')}}",
  '@now("month")': "{{$date.now|startOfMonth|format('yyyy-MM-dd HH:mm:ss')}}",
  '@now("week")': "{{$date.now|startOfWeek|format('yyyy-MM-dd HH:mm:ss')}}",
  '@now("day")': "{{$date.now|startOfDay|format('yyyy-MM-dd HH:mm:ss')}}",
  '@now("hour")': "{{$date.now|startOfHour|format('yyyy-MM-dd HH:mm:ss')}}",
  '@now("minute")': "{{$date.now|startOfMinute|format('yyyy-MM-dd HH:mm:ss')}}",
  '@now("second")': "{{$date.now|startOfSecond|format('yyyy-MM-dd HH:mm:ss')}}",
  '@image("200x100")': "{{$image.urlPlaceholder(format='png',width=200,height=100)}}",
  "@image('200x100', '#FF6600')": "{{$image.urlPlaceholder(format='png',width=200,height=100,backgroundColor='FF6600')}}",
  "@image('200x100', '#4A7BF7', 'Hello')": "{{$image.urlPlaceholder(format='png',width=200,height=100,backgroundColor='4A7BF7',text='Hello')}}",
  "@image('200x100', '#50B347', '#FFF', 'Mock.js')": "{{$image.urlPlaceholder(format='png',width=200,height=100,backgroundColor='50B347',textColor='FFFFFF',text='Faker.js')}}",
  "@image('200x100', '#894FC4', '#FFF', 'png', '!')": "{{$image.urlPlaceholder(format='png',width=200,height=100,backgroundColor='894FC4',textColor='FFFFFF',text='!')}}",
  '@dataImage("200x100")': "{{$image.dataUri(width=200,height=100)}}",
  // "@dataImage('200x100', 'Hello Mock.js!')": '',
  // "@dataImage('200x100', 'Hello Mock.js!', '#CCC')": '',
  '@boolean(true)': '{{$datatype.boolean}}',
  '@boolean(false)': '{{$datatype.boolean}}',
  '@boolean(1, 9, true)': '{{$datatype.boolean(probability=0.1)}}',
  '@integer(10000)': '{{$number.int(min=10000)}}',
  '@integer(60, 100)': '{{$number.int(min=60,max=100)}}',
  '@float(0)': '{{$number.float(min=0)}}',
  '@float(60, 100)': '{{$number.float(min=60,max=100)}}',
  '@float(60, 100, 3)': '{{$number.float(min=60,max=100,fractionDigits=3)}}',
  '@float(60, 100, 3, 5)': '{{$number.float(min=60,max=100,fractionDigits=3)}}',
  '@string("lower")': "{{$string.alpha(min=3,max=7,casing='lower')}}",
  '@string("upper")': "{{$string.alpha(min=3,max=7,casing='upper')}}",
  '@string("number")': '{{$string.numeric(min=3,max=7)}}',
  '@string("symbol")': '{{$string.symbol(min=3,max=7)}}',
  '@string("aeiou")': "{{$string.fromCharacters(characters=['a','e','i','o','u'],min=3,max=7)}}",
  '@string(7, 10)': "{{$string.sample(min=7,max=10)}}",
  "@string('lower', 1, 3)": "{{$string.alpha(min=1,max=3,casing='lower')}}",
  "@string('upper', 1, 3)": "{{$string.alpha(min=1,max=3,casing='upper')}}",
  "@string('number', 1, 3)": "{{$string.numeric(min=1,max=3)}}",
  "@string('symbol', 1, 3)": "{{$string.symbol(min=1,max=3)}}",
  '@character("lower")': "{{$string.alpha(min=1,max=1,casing='lower')}}",
  '@character("upper")': "{{$string.alpha(min=1,max=1,casing='upper')}}",
  '@character("number")': "{{$string.numeric(min=1,max=1)}}",
  '@character("symbol")': "{{$string.symbol(min=1,max=1)}}",
  '@character("aeiou")': "{{$string.fromCharacters(characters=['a','e','i','o','u'],min=1,max=1)}}"
};
function mockUpgrade(oldStr) {
  var _map$oldStr;
  if (typeof oldStr === 'undefined') {
    return oldStr;
  }
  return (_map$oldStr = map[oldStr]) !== null && _map$oldStr !== void 0 ? _map$oldStr : oldStr;
}
exports.mockUpgrade = mockUpgrade;
